import { DSSocial } from 'shared-definitions/types'
import { ApiSocialsProps } from 'data-source/types.wp'
import { pLinkExternalMapper } from './pLinkMapper'

export function socialsMapper(socials: ApiSocialsProps[]): DSSocial[] {
  return socials
    .filter(social => social.url !== '')
    .map(i => ({
      icon: i.icon,
      pLink: pLinkExternalMapper(i.url),
      title: i.title ?? i.icon,
    }))
}
